var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSelfExclusion = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_self_exclusion",
    d: "M174.379,454.4a3.548,3.548,0,0,0-.225-7.092l-.114,0a3.462,3.462,0,0,0-3.375,3.54v.173a3.547,3.547,0,0,0,3.713,3.374Zm1.136,4.044h0a5.4,5.4,0,0,1,1.163-3.364.978.978,0,0,0-.519.2,3.26,3.26,0,0,1-4.2-.021.929.929,0,0,0-.806-.189,6.175,6.175,0,0,0-3.718,5.338c-.091.833.346,2.863,6.591,2.893a16.624,16.624,0,0,0,3.872-.359A5.449,5.449,0,0,1,175.515,458.444Zm5.477-4.5h0a4.448,4.448,0,1,0,4.433,4.463v-.014A4.44,4.44,0,0,0,181,453.943Zm1.993,5.149h-3.8a.6.6,0,0,1,0-1.2h3.8a.6.6,0,1,1,0,1.2Z",
    transform: "translate(-167.425 -447.306)",
    fill: "#8d939c"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSelfExclusion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_self_exclusion.588ecc71dd6ce698b999135c83e4f6ff.svg";